/* ============
 * The initial state of the alert module.
 * ============
 */
export default {
  managementProtocolTemplate: {},
  protocolList: [],
  loading: false
};
